import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from "@app/constants/Common";
import {requestGetCandidateCareerRefCheck, requestUpdateCandidateCareerRefCheck, requestDownloadCandidateCareerRefCheckFile} from "@app/services/CandidateService";
import {alertMessage, showMessage} from "@app/constants/Messages";
import {requestDeleteExcludeReceiverIds} from "@pages/dvtjcuv/service/DVTJCUVSearchCddJobService";
import request from '@app/utils/apiRequest';


const CareerSummaryRefCheckListModal = (props) => {
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [refChecks, setRefChecks] = useState([]);
    const [isProcessing, setProcessing] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [notes, setNotes] = useState('');


    const {careerSummaryId, isShow, onClose} = props

    const fetchCandidateSummaryRefCheck = async (careerSumId) => {
        const res = await requestGetCandidateCareerRefCheck(careerSumId);
        if (res.sts_code === ResponseCode.SUCCESS) {
            setRefChecks(res.content.career_ref_checks)
        }
    }

    useEffect(() => {
        if (careerSummaryId) {
            fetchCandidateSummaryRefCheck(careerSummaryId)
        }
    }, [careerSummaryId]);

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }

    },[])

    const onAddRefCheck = () => {
        // const request = {
        //     career_sum_id: careerSummaryId,
        //     files: selectedFiles,
        //     notes: notes
        // }

        const data = new FormData();
        data.append('career_sum_id', careerSummaryId || '')
        data.append('notes', notes || '')
        selectedFiles.forEach(file => {
            data.append('files', file, file.name);
        })
        requestUpdateCandidateCareerRefCheck(data).then(res => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                alertMessage(res.sts_code, false, true)
                fetchCandidateSummaryRefCheck(careerSummaryId)
            } else {
                showMessage(res.message, true, true)
            }
        })
    }

    const onDeleteRefCheck = (ids) => {
        if (window.confirm("Bạn chắc chắn muốn xóa ref check này?") === true) {
            const requestBody = {career_summary_id: careerSummaryId}
            requestBody.receiver_ids = ids;
            requestDeleteExcludeReceiverIds(requestBody).then(res => {
                if (res.sts_code === ResponseCode.SUCCESS) {
                    alertMessage(res.sts_code, false, true)
                    fetchCandidateSummaryRefCheck(careerSummaryId)
                } else {
                    showMessage(res.message, true, true)
                }
            })
        }
    }

    const onSelectFiles = (event) => {
        setSelectedFiles(Array.from(event.target.files));
    };

    const onDeleteCareerRefCheck = (item) => {
    };


    return (
        <>
            <Modal show={isShow}
                   fullscreen style={{zIndex: 3002}}
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Career summary Ref checks</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body style={{overflowY: 'auto'}}>
                    <div className={'card card-default'}>
                        <div className='card-header'>
                            <h3 className='card-title text-bold'>Danh sách ref checks</h3>
                            <div className={'card-tools'} style={{width: '50%'}}>
                                <label>Chọn file</label>
                                <div className={'row'}>
                                    <div className='form-group'>
                                        <div className='custom-file'>
                                            <input
                                                type='file'
                                                className='custom-file-input'
                                                id='customFile'
                                                name='files'
                                                multiple
                                                onChange={(event) => onSelectFiles(event)}
                                            />
                                            <label
                                                className='custom-file-label'
                                                htmlFor='customFile'
                                            >
                                                {/* {selectedFiles[0]} */}
                                                {selectedFiles.map((item) => {
                                                    return `${item.name}; `;
                                                })}
                                            </label>
                                        </div>
                                    </div>
                                    <input className={'form-control ml-2 col-sm-5'}
                                           type='text'
                                           value={notes}
                                           onChange={(event) => setNotes(event.target.value)}
                                           placeholder={'Notes'}
                                    />
                                    <button type='button'
                                            className='btn btn-info btn-sm float-right'
                                            disabled={selectedFiles.length === 0 || isProcessing}
                                            onClick={onAddRefCheck}>
                                        {isProcessing ? 'Processing...' : 'Add ref check'}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='card-body table-responsive'>
                            <table
                                className='table table-hover table-bordered text-nowrap text-center'
                                style={{
                                    maxHeight: '80vh',
                                    overflow: 'scroll',
                                }}
                            >
                                <thead>
                                <tr>
                                    <th>STT</th>
                                    <th>Ref Check File</th>
                                    <th>Upload time</th>
                                    <th>Notes</th>
                                    <th>Hành động</th>
                                </tr>
                                </thead>
                                <tbody>
                                {refChecks.map((item, index) => {
                                    return <tr key={`compare-candidate-excel_${index}`}>
                                        <td>{index + 1}</td>
                                        <td>
                                            <a href={`${process.env.REACT_APP_API_BASE_URL}/candidate/detail/career-summary-ref-check-file?ref_check_file_key=${item.file_key}`}
                                                target="_blank" rel="noreferrer">
                                                {item.file_ref_check_name}
                                            </a>
                                        </td>
                                        <td>{item.created_date_time}</td>
                                        <td>{item.note}</td>
                                        <td>
                                            {/*<button className='btn btn-danger' type={'button'}*/}
                                            {/*        onClick={() => onDeleteCareerRefCheck(item)}>*/}
                                            {/*    Xóa*/}
                                            {/*</button>*/}
                                        </td>
                                    </tr>
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CareerSummaryRefCheckListModal;
